<template>
  <GridContainer>
    <RouterView v-if="!isLoading"/>
    <BaseLoader v-else></BaseLoader>
  </GridContainer>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { RouterView } from "vue-router";
import useScopeStore from "@/stores/scope";
import useOrganizationStore from "@/stores/organization"

const { fetchScopeList } = useScopeStore();
const { fetchOrganizationList } = useOrganizationStore();

const isLoading = ref(false)

onMounted(async () => {
  try{
    isLoading.value = true
    await fetchScopeList();
    await fetchOrganizationList();
  } catch (e) {
    console.error(e)
  } finally {
    isLoading.value = false
  }

})
</script>
